import {gql} from "graphql-tag";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const relatedSiteFields = `
id
uniqueId
title
url
`;


export const CREATE_RELATED_SITE_MUTATION = gql`
mutation CreateRelatedSiteMutation($input: RelatedSiteInputObject!) {
  createRelatedSiteMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${relatedSiteFields}
    }
  }
}
`


export const UPDATE_RELATED_SITE_MUTATION = gql`
mutation UpdateRelatedSiteMutation($input: RelatedSiteInputObject!) {
  updateRelatedSiteMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${relatedSiteFields}
    }
  }
}
`


export const DELETE_RELATED_SITE_MUTATION = gql`
mutation DeleteRelatedSiteMutation($uniqueId: String!) {
  deleteRelatedSiteMutation(uniqueId: $uniqueId) {
    ${baseResponseGraphqlField}
  }
}
`


export const GET_RELATED_SITES = gql`
query GetRelatedSites($filtering: RelatedSiteFilteringInputObject) {
  getRelatedSites(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${relatedSiteFields}
    }
  }
}
`
